export default "__VITE_ASSET__CvsGB2Ml__"